module.exports = __webpack_public_path__ + "img/moonshine-jug.63f1a0c4.png";